import React from 'react'

function Labels() {
  return (
    <div>Labels</div>
  )
}

export default Labels